import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LandingContatoComponent } from './landing-contato.component';

@NgModule({
  declarations: [
    LandingContatoComponent
  ],
  imports: [
    RouterModule,
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LocalizeRouterModule
  ],
  exports: [
    LandingContatoComponent
  ]
})

export class LandingContatoModule { }
